(() => {
  const root =
    document.querySelector('[data-pitb-search-page]') ||
    document.querySelector('[data-pitb-all-catalog]') ||
    document.querySelector('[data-pitb-preorder-catalog]');
  if (!root) return;

  const isNativeSearchPage = root.hasAttribute('data-pitb-search-page');
  const isPreorderCatalog = root.hasAttribute('data-pitb-preorder-catalog');

  const shop = root.querySelector('[data-pitb-shop]');
  const shopBody = shop && shop.querySelector('[data-pitb-shop-body]');
  if (!shop || !shopBody) return;

  const RESULTS_PER_PAGE = 24;
  const INTERNAL_HANDLES = new Set(['tff-sg-popup-2026', 'pitb-sg-popup-24-sep-2026', 'pitb-order-counter']);
  const COLLECTION_HANDLES = [
    'all',
    'pitb-preorder',
    'pitb-figures',
    'pitb-fashion',
    'pitb-lifestyle',
  ];
  const ATC_SVG = `<svg class="pitb-pc__atc-icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle class="pitb-pc__atc-round" cx="20" cy="20" r="19" fill="#F3F4F6" stroke="transparent" stroke-width="2"></circle><path class="pitb-pc__atc-bag" d="M14.5659 29.353C13.9887 29.353 13.4968 29.1497 13.0903 28.7432C12.6837 28.3367 12.4805 27.8448 12.4805 27.2676V16.4869C12.4805 15.9096 12.6837 15.4176 13.0903 15.0111C12.4968 14.6047 13.9887 14.4015 14.5659 14.4015H16.2074C16.2184 13.3638 16.5936 12.4787 17.3328 11.7461C18.0721 11.0134 18.9609 10.647 19.9992 10.647C21.0373 10.647 21.9264 11.0134 22.6665 11.7461C23.4064 12.4787 23.7818 13.3638 23.7928 14.4015H25.4343C26.0115 14.4015 26.5034 14.6047 26.9099 15.0111C27.3165 15.4176 27.5198 15.9096 27.5198 16.4869V27.2676C27.5198 27.8448 27.3165 28.3367 26.9099 28.7432C26.5034 29.1497 26.0115 29.353 25.4343 29.353H14.5659ZM14.5659 27.2676H25.4343V16.4869H23.7928V18.1942C23.7928 18.4868 23.6922 18.7337 23.491 18.9349C23.2896 19.1362 23.0427 19.2369 22.7501 19.2369C22.4575 19.2369 22.2106 19.1362 22.0092 18.9349C21.808 18.7337 21.7074 18.4868 21.7074 18.1942V16.4869H18.2928V18.1942C18.2928 18.4868 18.1922 18.7337 17.991 18.9349C17.7896 19.1362 17.5427 19.2369 17.2501 19.2369C16.9575 19.2369 16.7106 19.1362 16.5092 18.9349C16.308 18.7337 16.2074 18.4868 16.2074 18.1942V16.4869H14.5659V27.2676ZM18.2983 14.4015H21.7019C21.6909 13.9412 21.5203 13.5479 21.1902 13.2217C20.86 12.8956 20.4632 12.7325 19.9997 12.7325C19.536 12.7325 19.1392 12.8956 18.8094 13.2217C18.4797 13.5479 18.3093 13.9412 18.2983 14.4015Z" fill="#1A191A"></path></svg>`;

  let loading = false;
  let allMatches = [];
  let catalogCache = null;

  // pitb-landing.js also paginates the homepage grid (from Liquid sections). Expose
  // readiness so exactly one owner handles a given pager click: Liquid pagination until
  // the full catalog has been fetched, this engine from then on. Without this both
  // scripts would intercept the same click and race to write into the grid.
  window.PITB_JS_GRID = { ready: () => allMatches.length > 0 };

  const pitbClosed =
    root.dataset.pitbClosed === '1' ||
    Boolean(window.PITB_ORDER_CAP && (window.PITB_ORDER_CAP.closeState || window.PITB_ORDER_CAP.fullyBooked));

  const getQuery = () => new URLSearchParams(window.location.search).get('q')?.trim() || '';
  const getPage = () => Math.max(1, Number(new URLSearchParams(window.location.search).get('page') || '1'));
  const isBrowseMode = () => !getQuery();

  const getCatalogBasePath = () => {
    const base = shop.dataset.pitbCatalogUrl || window.location.pathname || '/collections/pitb-preorder';
    try {
      return new URL(base, window.location.origin).pathname || '/collections/pitb-preorder';
    } catch (_error) {
      return String(base).split('?')[0] || '/collections/pitb-preorder';
    }
  };

  const buildBrowseUrl = (page, filter) => {
    const params = new URLSearchParams();
    if (page > 1) params.set('page', String(page));
    if (filter && filter !== 'all') params.set('pitb_filter', filter);
    const qs = params.toString();
    return `${getCatalogBasePath()}${qs ? `?${qs}` : ''}`;
  };

  const buildSearchUrl = (query, page, filter) => {
    if (!query) return buildBrowseUrl(page, filter);

    const params = new URLSearchParams();
    params.set('q', query);
    if (isNativeSearchPage) {
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
    }
    if (page > 1) params.set('page', String(page));
    if (filter && filter !== 'all') params.set('pitb_filter', filter);
    return `${isNativeSearchPage ? '/search' : '/products'}?${params.toString()}`;
  };

  const buildResultsUrl = (page, filter) => {
    const query = getQuery();
    return query ? buildSearchUrl(query, page, filter) : buildBrowseUrl(page, filter);
  };

  const getFilter = () => {
    const key = new URLSearchParams(window.location.search).get('pitb_filter') || 'all';
    return key === 'pitb-preorder' ? 'all' : key;
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const handleize = (value) =>
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  const formatMoney = (amount) => {
    const cents = Math.round(Number(amount) * 100);
    const formatted = (cents / 100).toFixed(2);
    return `${formatted} SGD`;
  };

  const isInternal = (product) => {
    if (INTERNAL_HANDLES.has(product.handle)) return true;
    const tags = (product.tags || []).map((tag) => String(tag).toLowerCase());
    return tags.includes('pitb-entry-fee') || tags.includes('pitb-internal');
  };

  const getCollections = (tags) => {
    const tagList = (tags || []).map((tag) => String(tag).toLowerCase()).join(',');
    const list = ['all', 'pitb-preorder'];
    if (tagList.includes('figures') || tagList.includes('sg exclusive') || tagList.includes('sg-exclusive')) {
      list.push('pitb-figures');
    }
    if (tagList.includes('fashion') || tagList.includes('collectibles')) {
      list.push('pitb-fashion');
    }
    if (tagList.includes('lifestyle')) {
      list.push('pitb-lifestyle');
    }
    return list.join(',');
  };

  const matchesQuery = (product, query) => {
    const q = query.trim().toLowerCase();
    if (!q) return false;
    const qHandle = handleize(q);
    const qSpaced = q.replace(/-/g, ' ');
    const handle = String(product.handle || '').toLowerCase();
    const title = String(product.title || '').toLowerCase();
    return (
      handle.includes(qHandle) ||
      handle.includes(q) ||
      (qSpaced && title.includes(qSpaced)) ||
      title.includes(q)
    );
  };

  const productMatchesFilter = (product, filter) => {
    if (!filter || filter === 'all') return true;
    return getCollections(product.tags).split(',').includes(filter);
  };

  const pickVariant = (product) => {
    const variants = product.variants || [];
    return variants.find((variant) => variant.available) || variants[0] || null;
  };

  /*
    Storefront /collections/.../products.json does NOT include product.available.
    Older logic required product.available && variant.available → every card looked sold out.
    Prefer variant.available; only treat product.available when the API actually sends it
    (Liquid catalog index / product.js).
  */
  const productAvailable = (product, variant) => {
    const variants = product.variants || [];
    if (variant && variant.available) return true;
    if (variants.some((v) => v.available)) return true;
    if (product.available === true) return true;
    if (product.available === false) return false;
    return false;
  };

  const productPriceCents = (product) => {
    const prices = (product.variants || [])
      .map((variant) => Number(variant.price))
      .filter((price) => Number.isFinite(price));
    if (!prices.length) return 0;
    return Math.min(...prices);
  };

  const isInviteOnly = (tags) => {
    const list = (tags || []).map((tag) => String(tag).toLowerCase().replace(/\s+/g, '-'));
    return list.some((tag) =>
      [
        'pitb-invite-only',
        'by-invite-only',
        'by_invite_only',
        'by-invited-only',
        'by_invited_only',
        'invite-only',
        'invited-only',
      ].includes(tag)
    );
  };

  /*
    Default listing order (home, collection, search), applied to the FULL result set before
    pagination so a sold-out item never sits on page 1 above something purchasable:
      0  Available Online — purchasable, regular
      1  Invite Only — purchasable, invite-only (shown after regular products)
      2  Sold Out Online — not purchasable online (including sold-out Invite Only)
    The sort is a stable partition, so merchandising order is kept inside each group.
    Availability is the Shopify variant flag (online purchasability), not onsite stock.
    While purchases are closed nothing is on sale online, so the order is left untouched.
  */
  const availabilityRank = (product) => {
    if (!productAvailable(product, pickVariant(product))) return 2;
    return isInviteOnly(product.tags) ? 1 : 0;
  };

  const groupByAvailability = (list) => {
    if (pitbClosed) return list;
    return list
      .map((product, index) => ({ product, index, rank: availabilityRank(product) }))
      .sort((a, b) => a.rank - b.rank || a.index - b.index)
      .map((entry) => entry.product);
  };

  const buildCard = (product) => {
    const variant = pickVariant(product);
    const available = productAvailable(product, variant);
    const inviteOnly = isInviteOnly(product.tags);
    const price = productPriceCents(product);
    const collections = getCollections(product.tags);
    const title = product.title || '';
    const url = `/products/${product.handle}`;
    const image = product.images && product.images[0] ? product.images[0] : null;
    const imageSrc = image?.src || '';

    const article = document.createElement('article');
    article.className = 'pitb-pc';
    article.setAttribute('data-pitb-card', '');
    article.dataset.handle = product.handle || '';
    article.dataset.collections = collections;
    article.dataset.price = String(Math.round(price * 100));
    article.dataset.available = available ? '1' : '0';
    article.dataset.title = title.toLowerCase();

    const media = document.createElement('a');
    media.className = 'pitb-pc__media';
    media.href = url;
    media.setAttribute('aria-label', title);

    if (imageSrc) {
      const img = document.createElement('img');
      img.className = 'pitb-pc__img';
      img.loading = 'lazy';
      img.alt = title;
      img.src = imageSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_604x$1$3');
      if (!img.src.includes('_604x')) {
        img.src = imageSrc;
      }
      img.sizes = '(min-width: 750px) 22vw, 42vw';
      img.srcset = [
        `${imageSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_160x$1$3')} 160w`,
        `${imageSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_302x$1$3')} 302w`,
        `${imageSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_604x$1$3')} 604w`,
      ].join(', ');
      media.appendChild(img);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'pitb-pc__placeholder';
      placeholder.textContent = title.length > 28 ? `${title.slice(0, 25)}…` : title;
      media.appendChild(placeholder);
    }

    if (inviteOnly && available) {
      const badge = document.createElement('span');
      badge.className = 'pitb-pc__badge pitb-pc__badge--invite';
      badge.textContent = 'By Invite Only';
      media.appendChild(badge);
    } else if (!available && !pitbClosed) {
      // Closed state has nothing on sale online, so the sold-out badge is noise —
      // it would appear on every card. Mirrors pitb-product-card.liquid.
      const badge = document.createElement('span');
      badge.className = 'pitb-pc__badge pitb-pc__badge--soldout';
      badge.textContent = inviteOnly ? 'Sold Out' : 'Sold Out Online';
      media.appendChild(badge);
    }

    const heading = document.createElement('h3');
    heading.className = 'pitb-pc__title';
    const titleLink = document.createElement('a');
    titleLink.href = url;
    titleLink.textContent = title;
    heading.appendChild(titleLink);

    const row = document.createElement('div');
    row.className = 'pitb-pc__row';

    const priceEl = document.createElement('span');
    priceEl.className = 'pitb-pc__price';
    priceEl.textContent = formatMoney(price);
    row.appendChild(priceEl);

    if (available && variant && !pitbClosed && !inviteOnly) {
      const productForm = document.createElement('product-form');
      productForm.className = 'pitb-pc__add';
      productForm.innerHTML = `<form method="post" action="/cart/add" class="pitb-pc__form" novalidate="novalidate" data-pitb-handle="${String(product.handle || '').replace(/[^\w-]/g, '')}" data-pitb-limit="${window.PITBQuantityLimit?.limitAttr(product.tags) ?? ''}"><input type="hidden" name="id" value="${variant.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="pitb-pc__atc" name="add" aria-label="Add ${escapeHtml(title)} to cart">${ATC_SVG}</button></form>`;
      row.appendChild(productForm);
    }

    article.append(media, heading, row);
    return article;
  };

  const updateSearchNote = (query) => {
    const shopNote = shop.querySelector('.pitb-landing__shop-note');
    if (!shopNote) return;
    if (query) {
      shopNote.textContent = `Showing results for “${query}”.`;
      shopNote.hidden = false;
      return;
    }
    shopNote.textContent = '';
    shopNote.hidden = true;
  };

  const scrollToShop = () => {
    const target = document.getElementById('pitb-shop-toolbar') || document.getElementById('pitb-preorder');
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  const renderResultsPage = (page) => {
    const filter = getFilter();
    // Catalog fetch failed (or hasn't landed) while browsing: keep whatever is already
    // in the grid — normally the server-rendered Liquid page — instead of clearing it
    // and showing a false "no products in this category" message. A real empty category
    // still renders below, because that case has a populated allMatches.
    if (!allMatches.length && isBrowseMode()) return;

    const filtered = allMatches.filter((product) => productMatchesFilter(product, filter));
    const totalPages = Math.max(1, Math.ceil(filtered.length / RESULTS_PER_PAGE));
    const currentPage = Math.min(page, totalPages);
    const start = (currentPage - 1) * RESULTS_PER_PAGE;
    const slice = filtered.slice(start, start + RESULTS_PER_PAGE);

    shopBody.innerHTML = '';

    if (slice.length === 0) {
      const q = getQuery();
      const activeFilter = getFilter();
      let emptyCopy = 'No products in this category yet.';
      if (q && (activeFilter === 'all' || allMatches.length === 0)) {
        emptyCopy = `No products found for &ldquo;${escapeHtml(q)}&rdquo;.`;
      }
      shopBody.innerHTML = `<p class="pitb-landing__empty" data-pitb-empty>${emptyCopy}</p>`;
      return;
    }

    const grid = document.createElement('div');
    grid.className = 'pitb-landing__grid';
    grid.setAttribute('data-pitb-grid', '');
    grid.setAttribute('data-pitb-search-results', '');
    slice.forEach((product) => grid.appendChild(buildCard(product)));
    shopBody.appendChild(grid);

    if (totalPages > 1) {
      const nav = document.createElement('nav');
      nav.className = 'pitb-landing__pager';
      nav.setAttribute('aria-label', 'Product pagination');
      nav.setAttribute('data-pitb-pager', '');
      nav.setAttribute('data-pitb-search-pager', '');

      const list = document.createElement('ul');
      list.className = 'pitb-landing__pager-list';

      const windowSize = 3;
      let windowStart = Math.max(1, currentPage - Math.floor(windowSize / 2));
      let windowEnd = windowStart + windowSize - 1;
      if (windowEnd > totalPages) {
        windowEnd = totalPages;
        windowStart = Math.max(1, windowEnd - windowSize + 1);
      }

      for (let p = 1; p <= totalPages; p += 1) {
        const li = document.createElement('li');
        li.setAttribute('data-pitb-pager-page', String(p));
        if (p >= windowStart && p <= windowEnd) li.classList.add('is-in-window');
        if (p === currentPage) {
          const span = document.createElement('span');
          span.className = 'pitb-landing__pager-link is-current';
          span.setAttribute('aria-current', 'page');
          span.textContent = String(p);
          li.appendChild(span);
        } else {
          const a = document.createElement('a');
          a.className = 'pitb-landing__pager-link';
          a.href = buildResultsUrl(p, filter);
          a.dataset.pitbPage = String(p);
          a.textContent = String(p);
          li.appendChild(a);
        }
        list.appendChild(li);
      }

      nav.appendChild(list);
      const meta = document.createElement('p');
      meta.className = 'pitb-landing__pager-meta';
      meta.textContent = `Page ${currentPage} of ${totalPages} · ${filtered.length} products`;
      nav.appendChild(meta);
      shopBody.appendChild(nav);
    }

    document.dispatchEvent(new CustomEvent('pitb:search-results-loaded'));
  };

  const fetchCollectionProducts = async (handle) => {
    // Storefront /collections/.../products.json hard-caps at 50 per page.
    // Requesting 250 still returns ≤50; treating that as "last page" truncated the catalog.
    const pageSize = 50;
    const products = [];
    for (let page = 1; page <= 40; page += 1) {
      const response = await fetch(
        `/collections/${handle}/products.json?limit=${pageSize}&page=${page}`,
        { credentials: 'same-origin' }
      );
      if (!response.ok) break;
      const data = await response.json();
      const batch = data.products || [];
      if (!batch.length) break;
      products.push(...batch);
      if (batch.length < pageSize) break;
    }
    return products;
  };

  const loadCatalog = async () => {
    if (catalogCache) return catalogCache;

    const merged = new Map();
    // Pre-order catalog: only the pre-order collection, then filter by tags.
    // Search / all-catalog: merge category collections for broader lookup.
    const handles = isPreorderCatalog
      ? ['pitb-preorder']
      : COLLECTION_HANDLES;

    try {
      for (const handle of handles) {
        const batch = await fetchCollectionProducts(handle);
        batch.forEach((product) => {
          if (!isInternal(product)) merged.set(product.id, product);
        });
      }
    } catch (_error) {
      /* fall through to embedded index */
    }

    if (merged.size === 0) {
      const embedded = document.getElementById('pitb-catalog-index');
      if (embedded?.textContent) {
        try {
          const parsed = JSON.parse(embedded.textContent);
          if (Array.isArray(parsed)) {
            parsed.forEach((product) => {
              if (!isInternal(product)) merged.set(product.id, product);
            });
          }
        } catch (_error) {
          /* ignore parse errors */
        }
      }
    }

    catalogCache = Array.from(merged.values());
    return catalogCache;
  };

  const ensureMatches = async () => {
    const catalog = await loadCatalog();
    const query = getQuery();

    if (query) {
      allMatches = groupByAvailability(catalog.filter((product) => matchesQuery(product, query)));
      shop.classList.add('pitb-landing__shop--search');
      shop.classList.remove('pitb-landing__shop--browse');
      updateSearchNote(query);
      return;
    }

    // Browse mode: full pre-order catalog, filter client-side across all products
    allMatches = catalog.filter((product) => {
      const collections = getCollections(product.tags).split(',');
      return collections.includes('pitb-preorder') || collections.includes('all');
    });
    if (allMatches.length === 0) allMatches = catalog.slice();
    allMatches = groupByAvailability(allMatches);
    shop.classList.add('pitb-landing__shop--browse');
    shop.classList.remove('pitb-landing__shop--search');
    updateSearchNote('');
  };

  const loadSearchResults = async (query, page = 1, pushUrl) => {
    if (loading) return;
    loading = true;
    const started = Date.now();
    shop.classList.add('is-loading');
    if (query) {
      shop.classList.add('pitb-landing__shop--search');
      updateSearchNote(query);
    }

    try {
      if (query) {
        const catalog = await loadCatalog();
        allMatches = groupByAvailability(catalog.filter((product) => matchesQuery(product, query)));
      } else {
        await ensureMatches();
      }

      if (pushUrl) {
        history.pushState(null, '', pushUrl);
      }

      renderResultsPage(page);
    } catch (_error) {
      shopBody.innerHTML =
        '<p class="pitb-landing__empty">Unable to load products. Please try again.</p>';
    } finally {
      loading = false;
      const wait = Math.max(0, 280 - (Date.now() - started));
      setTimeout(() => shop.classList.remove('is-loading'), wait);
    }
  };

  shop.addEventListener('click', (event) => {
    const usingJsGrid =
      shop.classList.contains('pitb-landing__shop--search') ||
      shop.classList.contains('pitb-landing__shop--browse');
    if (!usingJsGrid) return;

    const pagerLink = event.target.closest('[data-pitb-search-pager] a[href], [data-pitb-pager] a[href]');
    if (!pagerLink) return;
    // Catalog still loading — leave the click to the server-rendered pager rather than
    // rendering an empty grid from a not-yet-populated allMatches.
    if (!allMatches.length) return;

    event.preventDefault();
    const linkUrl = new URL(pagerLink.href, window.location.origin);
    const page = Math.max(1, Number(linkUrl.searchParams.get('page') || pagerLink.dataset.pitbPage || '1'));
    const filter = getFilter();
    const query = getQuery();

    history.pushState(null, '', buildResultsUrl(page, filter));
    shop.classList.add('is-loading');
    renderResultsPage(page);
    scrollToShop();
    setTimeout(() => shop.classList.remove('is-loading'), 280);

    if (query && allMatches.length === 0) {
      loadSearchResults(query, page);
    }
  });

  window.addEventListener('popstate', () => {
    const query = getQuery();
    if (query) {
      loadSearchResults(query, getPage());
      scrollToShop();
      return;
    }
    if (isNativeSearchPage || isPreorderCatalog || getFilter() !== 'all') {
      loadSearchResults('', getPage());
      scrollToShop();
      return;
    }
    // Unfiltered browse on all-catalog — reload Liquid pagination.
    window.location.reload();
  });

  document.addEventListener('pitb:catalog-filter-changed', () => {
    const apply = async () => {
      const started = Date.now();
      shop.classList.add('is-loading');
      try {
        await ensureMatches();
        history.replaceState(null, '', buildResultsUrl(1, getFilter()));
        renderResultsPage(1);
        scrollToShop();
      } finally {
        const wait = Math.max(0, 280 - (Date.now() - started));
        setTimeout(() => shop.classList.remove('is-loading'), wait);
      }
    };
    apply();
  });

  // The Liquid page can only order the 24 products it paginates, so page N of the server
  // render follows collection order. Once the full catalog is in, swap in the globally
  // grouped page — but only when it actually differs, to avoid a needless repaint.
  const correctServerRenderedPage = () => {
    if (!allMatches.length || pitbClosed) return;
    const page = getPage();
    const filtered = allMatches.filter((product) => productMatchesFilter(product, getFilter()));
    const expected = filtered
      .slice((page - 1) * RESULTS_PER_PAGE, page * RESULTS_PER_PAGE)
      .map((product) => product.handle);
    const rendered = Array.from(shopBody.querySelectorAll('[data-pitb-card]')).map(
      (card) => card.dataset.handle || ''
    );
    if (expected.length && expected.join('|') !== rendered.join('|')) renderResultsPage(page);
  };

  // Search query or pre-order category deep-links — replace Liquid with the full filtered set.
  // Empty search on /search resets q and lists the catalog with the chosen filter.
  // Unfiltered pre-order "All" keeps Liquid until a category chip is chosen.
  if (getQuery()) {
    shop.classList.add('pitb-landing__shop--search', 'is-loading');
    updateSearchNote(getQuery());
    loadSearchResults(getQuery(), getPage());
    scrollToShop();
  } else if (isNativeSearchPage) {
    shop.classList.add('pitb-landing__shop--browse', 'is-loading');
    loadSearchResults('', getPage());
    scrollToShop();
  } else if (isPreorderCatalog && getFilter() !== 'all') {
    shop.classList.add('pitb-landing__shop--browse', 'is-loading');
    loadSearchResults('', getPage());
    scrollToShop();
  } else if (isPreorderCatalog) {
    // Warm the full pre-order cache so category chips can filter without a reload.
    ensureMatches()
      .then(() => {
        shop.classList.add('pitb-landing__shop--browse');
        correctServerRenderedPage();
      })
      .catch(() => {});
  }
})();
